export default "// src/sass/main.scss\n\n$color-pack: false;\n\n@import '~vuetify/src/styles/main.sass';\n";